import { commentsData } from "../../../mocks/baogua";

export default function HotRead() {
  return (
    <section id="hotread" className="bg-[#f2ead9] py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="max-w-2xl mb-10">
          <h2 className="font-serif-cn text-2xl md:text-4xl font-black text-[#201d1a]">
            深度吃瓜 · <span className="text-[#ff4d3d]">热评风云榜</span>
          </h2>
          <p className="mt-3 text-[#201d1a]/60">
            高赞爆文的幕后声音：看看围观群众都怎么想，又有哪些神评被顶上来了。
          </p>
        </div>

        <div className="grid gap-6 lg:grid-cols-2">
          <article className="group overflow-hidden rounded-3xl bg-white border border-amber-900/10 hover:border-emerald-600/30 transition-colors cursor-pointer">
            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=modern%20flat%20illustration%20of%20young%20people%20gathered%20around%20a%20giant%20watermelon%20discussing%20and%20chatting%2C%20friendly%20community%20vibe%2C%20warm%20cream%20background%20with%20emerald%20green%20and%20coral%20red%20color%20palette%2C%20soft%20shadows%2C%20clean%20editorial%20style%2C%20no%20text&width=900&height=560&seq=baogua-feature-x1&orientation=landscape"
                alt="吃瓜群众围坐讨论热点的插画配图"
                className="w-full h-52 md:h-64 object-cover object-center"
              />
              <span className="absolute left-4 top-4 rounded-full bg-[#ff4d3d] text-white text-xs font-bold px-3 py-1">深度爆文</span>
              <span className="absolute right-4 top-4 rounded-full bg-white/90 text-emerald-700 text-xs font-medium px-3 py-1">职场 · 热议 6.9万</span>
            </div>
            <div className="p-5 md:p-6">
              <h3 className="font-serif-cn text-xl md:text-2xl font-bold text-[#201d1a] leading-snug group-hover:text-emerald-700 transition-colors">
                职场"摸鱼经济学"刷屏：年轻人追求的从来不是偷懒，而是高效
              </h3>
              <p className="mt-3 text-[#201d1a]/65 leading-relaxed">
                当"拒绝无效加班"成为新一代职场共识，一场关于工作时长与产出质量的讨论正在发酵。受访的上班族普遍表示，比起耗时间的"表面忙碌"，大家更希望企业关注真正的价值创造，让工作回归效率本身。
              </p>
              <div className="mt-4 flex items-center gap-4 text-sm text-[#201d1a]/55 flex-wrap">
                <span className="flex items-center gap-1"><i className="ri-chat-3-line w-4 h-4 flex items-center justify-center"></i>9800+ 条讨论</span>
                <span className="flex items-center gap-1"><i className="ri-heart-3-line w-4 h-4 flex items-center justify-center"></i>2.7万 人认同</span>
                <span className="text-emerald-600 font-medium flex items-center gap-1 ml-auto">围观讨论 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i></span>
              </div>
            </div>
          </article>

          <div className="flex flex-col gap-4">
            <div className="flex items-center justify-between">
              <h3 className="font-bold text-lg text-[#201d1a] flex items-center gap-2">
                <i className="ri-chat-quote-line w-5 h-5 flex items-center justify-center text-[#ff4d3d]"></i>
                高赞神评精选
              </h3>
              <span className="text-xs text-[#201d1a]/45">评论区持续火热中</span>
            </div>
            {commentsData.map((c) => (
              <article key={c.user} className="p-4 md:p-5 rounded-2xl bg-white border border-amber-900/10">
                <div className="flex items-center gap-3">
                  <span className={`grid w-9 h-9 rounded-full ${c.color} text-white items-center justify-center text-sm font-bold`}>
                    {c.avatar}
                  </span>
                  <div className="flex-1">
                    <p className="text-sm font-medium text-[#201d1a]">{c.user}</p>
                    <p className="text-xs text-[#201d1a]/40">{c.time}</p>
                  </div>
                  <span className="inline-flex items-center gap-1 rounded-full bg-emerald-600/10 text-emerald-700 text-xs px-2.5 py-1 whitespace-nowrap">
                    <i className="ri-arrow-up-line w-3.5 h-3.5 flex items-center justify-center"></i>顶 {c.likes}
                  </span>
                </div>
                <p className="mt-3 text-sm text-[#201d1a]/75 leading-relaxed">{c.text}</p>
                <div className="mt-3 flex items-center gap-4 text-xs text-[#201d1a]/45">
                  <span className="flex items-center gap-1 cursor-pointer hover:text-[#ff4d3d]"><i className="ri-thumb-up-line w-4 h-4 flex items-center justify-center"></i>赞</span>
                  <span className="flex items-center gap-1 cursor-pointer hover:text-[#ff4d3d]"><i className="ri-chat-1-line w-4 h-4 flex items-center justify-center"></i>{c.replies} 回复</span>
                  <span className="flex items-center gap-1 cursor-pointer hover:text-[#ff4d3d]"><i className="ri-share-line w-4 h-4 flex items-center justify-center"></i>转发</span>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}